import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { casinoTypes } from "../../../../lib/data/casinoTypes.data";
import { useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import { GamesCard } from ".";

import BackIcon from "../../../../assets/svg/BackIcon";

const CasinoCategory = () => {
  const navigate = useNavigate();
  const { category, provider, type } = useParams();
  const { isAuth } = useSelector((state) => state?.auth);
  const selectedData = casinoTypes?.[type]?.[provider]?.[category] || [];

  if (!selectedData || !selectedData?.length) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      {isAuth ? <HeaderAfterLogin /> : <Header />}
      <main className="main">
        <div className="CasinoCategoryHeading Deposit-Gateway-heading">
          <div className=" pagesHeading">

            <a className="back-link" onClick={() => navigate(-1)}>
                <BackIcon /> <span>Back</span>
            </a>
            
          </div>
        </div>
        <div className="CasinoGamesSection">
          <ul className="d-flex CasinoGamesImage">
            {selectedData &&
              selectedData?.map((game, idx) => {
                return <GamesCard card={game} key={idx} />;
              })}
          </ul>
        </div>
      </main>
    </div>
  );
};
export default CasinoCategory;
